import React from 'react';
import classnames from 'classnames';

const Spinner = ({ className, color, size }) => {
  const spinnerClasses = classnames(
    'Spinner',
    { [`Spinner--${color}`]: color, [`Spinner--${size}`]: size },
    className,
  );
  return <div className={spinnerClasses} />;
};

export default Spinner;
